import { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import {
  SimpleRegistrationSignupSchema,
  SimpleRegistrationSignupType,
} from "../schemas/SimpleRegistrationFormSchema";
import { simple_user_registeration } from "../constants/apis";

import InputWithLabel from "../components/InputWithLabel";
import Dropdown from "../components/DropDown";
// import OtpPopup from "../components/OtpPopup";
import {
  // IFIcon,
  // LogisticsIcon,
  // QualityAssuranceIcon,
  // SimplePaymentIcon,
  SpinnerIcon,
  TaramLogo,
} from "../components/Icons";

import {
  // COMPANY_REGION,
  COUNTRIES,
  PHONE_NO_COUNTRY_CODE,
} from "../constants/variable";
// import Tooltip from "../components/Tooltip";
import CustomModal from "../components/DealTracker/CustomModal";

// const serviceTooltip =
//   "You can choose any services you want. you need to choose at least one service. Note that the Payment service is only available for India";

export default function SignupPage() {
  // const [isAccountCreated, setIsAccountCreated] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  // const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    // getValues,
    // watch,
  } = useForm<SimpleRegistrationSignupType>({
    resolver: zodResolver(SimpleRegistrationSignupSchema),
  });

  // const isIndia = watch("company_reg_country") === "IN";

  const toggleModal = () => setIsOpen((prev) => !prev);

  // console.log(errors);

  const onHandleSubmit: SubmitHandler<SimpleRegistrationSignupType> = async (
    values,
  ) => {
    // console.log(values);
    // return;

    try {
      const response = await fetch(simple_user_registeration, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          first_name: values.firstName,
          // middle_name: values.middleName,
          last_name: values.lastName,
          company_name: values.companyName,
          work_email: values.workEmail,
          countryCode: values.countryCode,
          company_phone_number: values.businessPhone,
          // company_reg_number: values.companyRegNumber,
          // company_region: values.companyRegion,
          company_reg_country: values.company_reg_country,
          // user_services: values.services,
          pwd: values.password,
        }),
      });
      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }
      const data = await response.json();
      // console.log(data);
      if (data.status === "success") {
        // setIsAccountCreated(true);
        // toast.success(data.message);
        toggleModal();
      } else {
        // setIsAccountCreated(false);
        toast.success(data.message || "Something went wrong please try again");
      }
    } catch (error) {
      console.log(error);
    }
  };
  // console.log(errors);

  return (
    <section className="p-4 lg:p-0">
      <Link to={"/"} className="hover:underline text-gray-600">
        &#x2190; Home
      </Link>
      <div className="my-2">
        <Link to={"/"}>
          <TaramLogo className="w-28" />
        </Link>
      </div>

      <form
        onSubmit={handleSubmit(onHandleSubmit)}
        className="max-w-[600px] grid grid-cols-1 gap-2 md:grid-cols-2"
      >
        <div className="col-span-full mb-2">
          <h2 className="text-gray-800 text-3xl font-bold">
            Create Your Account
          </h2>
          <p className="text-gray-600 text-sm">
            Welcome! Registering with us is quick and easy. Simply fill out the
            form below to start exploring our services and benefits.
          </p>
        </div>

        <InputWithLabel
          label={"First Name"}
          placeholder="Enter here"
          id={"firstName"}
          {...register("firstName")}
          error={errors.firstName?.message}
        />
        <InputWithLabel
          label={"Last Name"}
          placeholder="Enter here"
          id={"lastName"}
          {...register("lastName")}
          error={errors.lastName?.message}
        />

        <InputWithLabel
          label={"Company Name"}
          placeholder="Enter here"
          id={"companyName"}
          {...register("companyName")}
          error={errors.companyName?.message}
        />

        {/* <InputWithLabel
          label={"Company Registration Number"}
          placeholder="Enter here"
          id={"companyRegNumber"}
          {...register("companyRegNumber")}
          error={errors.companyRegNumber?.message}
        /> */}

        {/* <Dropdown
          label="Company Region"
          placeholder="Select Company Region"
          options={COMPANY_REGION}
          {...register("companyRegion")}
          error={errors.companyRegion?.message}
        /> */}

        <Dropdown
          label="Company Registered Country"
          placeholder="Select Registered Country"
          options={COUNTRIES}
          {...register("company_reg_country")}
          error={errors.company_reg_country?.message}
        />

        <InputWithLabel
          label={"Work Email"}
          placeholder="Enter here"
          id={"workEmail"}
          {...register("workEmail")}
          error={errors.workEmail?.message}
        />

        <div className="relative grid grid-cols-[80px_1fr]">
          <label
            htmlFor="businessPhone"
            className="col-span-full text-[#344054] text-sm font-medium"
          >
            Business Phone Number
          </label>
          <Dropdown
            // label="Country Code"
            label=""
            placeholder="Select a country code"
            options={PHONE_NO_COUNTRY_CODE.map((el) => ({
              label: el.label,
              value: el.countryCode,
            }))}
            {...register("countryCode")}
            // error={errors.countryCode?.message}
            error=""
            className="border-r-0 rounded-r-none"
          />

          <InputWithLabel
            // label={"Business Phone Number"}
            label=""
            placeholder="Enter here"
            id={"businessPhone"}
            {...register("businessPhone")}
            // error={errors.businessPhone?.message}
            error=""
            className="rounded-l-none"
          />
          <small className="absolute -bottom-2 left-1 col-span-full text-red-500 block">
            {errors.businessPhone?.message || errors.countryCode?.message}
          </small>
        </div>

        {
          // <div className="col-span-full">
          //   <div className="flex items-center gap-2">
          //     <label
          //       htmlFor="businessPhone"
          //       className="text-[#344054] text-sm font-medium"
          //     >
          //       Services
          //     </label>
          //     {/* <Tooltip content={serviceTooltip} /> */}
          //     <small className="text-red-500 text-sm font-normal">
          //       {errors.services?.root?.message}
          //     </small>
          //   </div>
          //   <div className="flex flex-wrap gap-3">
          //     <label
          //       className={`flex items-center gap-1 text-[#344054] text-sm font-medium px-[10px] py-2 rounded-2xl cursor-pointer shadow-[0px_1px_24px_0px_#00000014] ${
          //         !isIndia && "opacity-40 cursor-not-allowed"
          //       }`}
          //     >
          //       <input
          //         type="checkbox"
          //         className="size-4 disabled:cursor-not-allowed"
          //         {...register("services.simple_payment")}
          //         disabled={!isIndia}
          //       />
          //       <SimplePaymentIcon className="size-6" />
          //       Payment
          //     </label>
          //     <label className="flex items-center gap-1 text-[#344054] text-sm font-medium px-[10px] py-2 rounded-2xl cursor-pointer shadow-[0px_1px_24px_0px_#00000014]">
          //       <input
          //         type="checkbox"
          //         className="size-4"
          //         {...register("services.invoice_factoring")}
          //       />
          //       <IFIcon className="size-6" />
          //       Invoice Factoring
          //     </label>
          //     <label className="flex items-center gap-1 text-[#344054] text-sm font-medium px-[10px] py-2 rounded-2xl cursor-pointer shadow-[0px_1px_24px_0px_#00000014]">
          //       <input
          //         type="checkbox"
          //         className="size-4"
          //         {...register("services.logistics")}
          //       />
          //       <LogisticsIcon className="size-5" />
          //       Logistics
          //     </label>
          //     <label className="flex items-center gap-1 text-[#344054] text-sm font-medium px-[10px] py-2 rounded-2xl cursor-pointer shadow-[0px_1px_24px_0px_#00000014]">
          //       <input
          //         type="checkbox"
          //         className="size-4"
          //         {...register("services.quality_assurance")}
          //       />
          //       <QualityAssuranceIcon className="size-6" />
          //       Quality Assurance
          //     </label>
          //   </div>
          // </div>
        }

        <InputWithLabel
          label={"Password"}
          type="password"
          id={"password"}
          placeholder="Enter password"
          {...register("password")}
          error={errors.password?.message}
        />
        <InputWithLabel
          label={"Retype Password"}
          type="password"
          id={"retypePassword"}
          placeholder="Enter retype password"
          {...register("retypePassword")}
          error={errors.retypePassword?.message}
        />

        <button
          type="submit"
          disabled={isSubmitting}
          className="mt-2 col-span-full flex justify-center items-center bg-custom-dark-blue-new text-white py-2 rounded-lg shadow-md hover:bg-blue-900 transition"
        >
          {isSubmitting ? (
            <SpinnerIcon className="size-6 text-gray-200 animate-spin fill-blue-600" />
          ) : (
            "Sign Up"
          )}
        </button>
      </form>
      <p className="text-center text-sm text-gray-600 mt-4">
        Already have an account?{" "}
        <Link to="/login" className="text-blue-600 hover:underline">
          Log in
        </Link>
      </p>

      {/* {isAccountCreated && <OtpPopup emailId={getValues("workEmail")} />} */}
      <RegisterSuccessModal isOpen={isOpen} toggleModal={toggleModal} />
    </section>
  );
}

function RegisterSuccessModal({
  isOpen,
  toggleModal,
}: {
  isOpen: boolean;
  toggleModal: () => void;
}) {
  const navigate = useNavigate();

  return (
    <CustomModal
      open={isOpen}
      onClose={toggleModal}
      className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center"
    >
      {/* Success Icon */}
      <div className="flex justify-center mb-6">
        <div className="bg-green-100 p-4 rounded-full">
          <svg
            className="w-12 h-12 text-green-600"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
      </div>

      {/* Title */}
      <h2 className="text-2xl font-semibold text-gray-800 mb-2">
        Registration Successful 🎉
      </h2>

      {/* Description */}
      <p className="text-gray-500 mb-6">
        Your account is currently under review. We’ll notify you via email once
        it’s approved and ready for login.
      </p>

      {/* Button */}
      <button
        onClick={() => {
          toggleModal();
          navigate("/");
        }}
        className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-2.5 rounded-lg transition-all duration-200"
      >
        Continue
      </button>
    </CustomModal>
  );
}
